import { get } from 'lodash';

import { FIELD_PATHS } from '@funnels/constants';
import { AnyFormValues, Owner, StoreApplicant } from '@funnels/types';

export const hasExclusiveAssetOwnershipByApplicantType = (
  formValues: AnyFormValues,
  assetOwners: Owner[],
  applicantType: string
) => {
  const filteredApplicantIds = get(formValues, FIELD_PATHS.APPLICANTS(), [])
    .filter(
      (applicant: StoreApplicant) => get({ applicants: [applicant] }, FIELD_PATHS.APPLICANT_TYPE(0)) === applicantType
    )
    .map((guarantor: StoreApplicant) => guarantor.id);

  return assetOwners.every((owner: Owner) => filteredApplicantIds.includes(owner.applicantId));
};
